/* NHD - Test, Don't Guess, Heart Palpitations variant.
   Loaded only on templates/page.palp-heart-testing.json.
   Every query is scoped to #nhd-tdg-palpitations so nothing in the Prestige
   theme is touched. Inline handlers from the source file were moved here. */
(function(){
  var root=document.getElementById('nhd-tdg-palpitations'); if(!root) return;
  /* scroll reveal */
  try{
    if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var rvEls=root.querySelectorAll('.tdg-sec-head,.tdg-prob-item,.tdg-big-card,.tdg-big-close,.tdg-clue-step,.tdg-tier-card,.tdg-assure-card,.tdg-proof-card,.tdg-cmp-wrap,.tdg-trust,.tdg-tl-step,.tdg-disc-card,.tdg-faq-item,.tdg-final-card,.tdg-doc-photos');
      if(rvEls.length){
        root.classList.add('tdg-anim');
        rvEls.forEach(function(el){el.classList.add('tdg-rv');});
        rvEls.forEach(function(el){
          var sibs=Array.prototype.filter.call(el.parentElement.children,function(c){return c.classList&&c.classList.contains('tdg-rv');});
          var i=sibs.indexOf(el); if(i>0) el.style.setProperty('--nhd-rvd',(Math.min(i,5)*90)+'ms');
        });
        if('IntersectionObserver' in window){
          var settle=function(el){var d=parseInt((el.style.getPropertyValue('--nhd-rvd')||'0'),10)||0;window.setTimeout(function(){el.classList.remove('tdg-rv','tdg-in');el.style.removeProperty('--nhd-rvd');},700+d);};
          var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('tdg-in');io.unobserve(en.target);settle(en.target);}});},{threshold:.12,rootMargin:'0px 0px -60px 0px'});
          rvEls.forEach(function(el){io.observe(el);});
        }else{rvEls.forEach(function(el){el.classList.remove('tdg-rv');});}
      }
    }
  }catch(e){root.classList.remove('tdg-anim');}
  /* bigger-picture parallax */
  try{
    if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var pbg=root.querySelector('.tdg-big-bg');
      if(pbg){
        var psec=pbg.parentElement,pticking=false;
        var ppos=function(){
          var r=psec.getBoundingClientRect(),vh=window.innerHeight||1;
          if(r.bottom>-80&&r.top<vh+80){
            var prog=(r.top+r.height/2-vh/2)/((vh+r.height)/2);
            pbg.style.transform='translateY('+(prog*-56).toFixed(1)+'px) scale(1.02)';
          }
          pticking=false;
        };
        var ponscroll=function(){if(!pticking){pticking=true;window.requestAnimationFrame(ppos);}};
        window.addEventListener('scroll',ponscroll,{passive:true});
        window.addEventListener('resize',ponscroll,{passive:true});
        ppos();
      }
    }
  }catch(e){}
  var toggle=document.getElementById('tdg-menu-toggle'),links=document.getElementById('tdg-navlinks');
  if(toggle&&links){toggle.addEventListener('click',function(){var open=links.classList.toggle('tdg-open');toggle.setAttribute('aria-expanded',open?'true':'false');});}
  function closeMenu(){if(links){links.classList.remove('tdg-open');}if(toggle){toggle.setAttribute('aria-expanded','false');}}
  root.querySelectorAll('a[href*="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var href=a.getAttribute('href')||'';
      var hashIdx=href.indexOf('#'); if(hashIdx===-1) return;
      var id=href.slice(hashIdx+1); if(!id) return;
      var el=document.getElementById(id); if(!el) return;
      if(hashIdx>0){
        var url; try{url=new URL(href,location.href);}catch(err){return;}
        var norm=function(p){return p.replace(/\/+$/,'');};
        if(url.origin!==location.origin||norm(url.pathname)!==norm(location.pathname)){closeMenu();return;}
      }
      e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'start'}); closeMenu();
    });
  });
  var s=document.getElementById('tdg-sticky-cta'),hero=root.querySelector('.tdg-hero');
  function onScroll(){
    if(!s||!hero) return;
    var r=hero.getBoundingClientRect();
    s.classList.toggle('tdg-show',r.bottom<80);
  }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
})();


/* ---------------------------------------------------------------------------
   WebinarJam attribution.
   Reads wj_user and wj_l from the URL, falls back to the wj_user_product
   cookie set by cookie.js, and writes them to Shopify cart attributes so they
   survive into checkout. Runs on load so it does not depend on cookie.js
   executing first. Same block as nhd-tdg.js on the good-better-best page.

   WJ_OFFER_HASH identifies WHICH WebinarJam offer sent the visitor. The
   good-better-best page does not send one, because the live pixel 174784752
   hardcodes the Heart Attack Proof hash 4vr02t1pck. Once the palpitations
   masterclass offer exists, put its hash here and change the pixel to read
   the wj_hash cart attribute instead of its hardcoded value. Until then this
   stays empty and no wj_hash attribute is written.
--------------------------------------------------------------------------- */
(function () {
  var WJ_OFFER_HASH = 'n7m13f2gh8'; /* "Test Don't Guess Offer", webinar 235, read from Advanced integration > Goal tracking 2026-09-20 */

  function run() {
    var q = new URLSearchParams(window.location.search);
    var user = q.get('wj_user');
    var live = q.get('wj_l') || '';

    if (!user) {
      var m = document.cookie.match(/(?:^|;\s*)wj_user_product=([^;]*)/);
      if (!m) return;
      var v = {};
      decodeURIComponent(m[1]).split('&').forEach(function (p) {
        var kv = p.split('=');
        v[kv[0]] = kv[1];
      });
      user = v.wj_user;
      live = v.wj_l || '';
    }
    if (!user) return;

    var attrs = { wj_user: user, wj_l: live };
    if (WJ_OFFER_HASH) { attrs.wj_hash = WJ_OFFER_HASH; }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  if (document.readyState === 'complete') { run(); }
  else { window.addEventListener('load', run); }
})();
